<template>
	<div ref="scrollContainer" id="page-po" v-loading.fullscreen.lock="loading" class="scrollable only-y">
    <el-row>
      <el-col style="padding-left:10px;">
        <InvoiceView @close="closeSelectedInvoice" @edit="editInvoice" :invoice="this.selectedInvoice"></InvoiceView>
      </el-col>
    </el-row>
    <InvoiceEditor :visible="invoiceEditorVisible" :editInvoice="selectedInvoice" @close="closeInvoiceEditor"></InvoiceEditor>
	</div>
</template>
<script>
import { mapActions, mapState, mapGetters } from 'vuex';
import InvoiceEditor from '@/components/invoice/invoice-editor'
import InvoiceView from './components/invoice-view'

export default {
  data() {
    return {
      invoiceEditorVisible : false,
			editSelectedInvoice : null
    };
  },components: {
    InvoiceEditor,
		InvoiceView
  },
  watch : {

  },
	methods: {
		openSalesOrderEditor(){
			this.openEditInvoiceDialog();
		},
		closeSelectedInvoice(){
			var index='/invoices';
			this.$router.push(index);
		},
		editInvoice(){
			this.invoiceEditorVisible=true;
		},
		closeInvoiceEditor(){
			this.invoiceEditorVisible=false;
			this.editSelectedInvoice=null;
		},
		...mapActions('invoices', [ 'selectInvoice']),
	},
	computed: {
		invoiceId(){
			return this.$route.params.invoiceId;
		},
		...mapState('invoices',['loading','selectedInvoice'])
	},
  mounted(){

  },
	created(){

		this.selectInvoice({invoiceId : this.invoiceId, index:null});
	}
}
</script>
<style lang="scss" scoped>
@import '../../../assets/scss/_variables';

.title {
	font-size : 1.6em;
	font-weight:bold;
	margin-right:20px;
	position:relative;
	float:left;
}
.customer-top-nav{
  height:80px;
}

.controls{
	position:relative;
	float:right;

	button{
		margin-left:20px;
	}
}

.el-table tr, .el-table__row{
  background-color: #f3f7fa;
}


@media (max-width: 1024px) {
  img.inventory {
    margin-top:20px;
    height:175px;
  }
}
</style>
